import React, {Component} from 'react';
import * as tracking from '../tracking';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import SelectPlan from '../components/trial-end/choose_plan';
import CompanyDetails, {EU_COUNTRIES_CODES} from '../components/trial-end/company_details';
import Licensing from '../components/trial-end/licensing';
import Payment from '../components/trial-end/payment';
import {createFragmentContainer, graphql} from 'react-relay';
import TrialEndHeader from '../components/trial-end/trial_end_header';
import Receipt from '../components/trial-end/receipt';
import ValidateCouponMutation from '../mutations/validate_coupon_mutation';
import LogoutMutation from '../mutations/logout_mutation';
import UpdateCompanyMutation from '../mutations/update_company_mutation.modern';
import Util from '../forecast-app/shared/util/util';
import OrderComplete from '../components/new-ui/order_complete';
import OnboardingCard from '../components/trial-end/onboarding';
import Moment from 'moment';
import NoPermission from '../components/trial-end/no_permission';
import CustomScrollDiv from '../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import {TIERS} from '../constants';
import {PERMISSION_TYPE} from '../Permissions';
import {hasPermission, personHasPermission, personIsClientUser, personIsVirtualUser} from '../forecast-app/shared/util/PermissionsUtil';

class trialEnd extends Component {
	constructor(props) {
		super(props);

		const company = this.props.viewer.company;
		const users = props.viewer.company.allPersons.edges.filter(edge => edge.node.active && !personIsClientUser(edge.node) && !personIsVirtualUser(edge.node)).length;
		const virtualUsers = props.viewer.company.allPersons.edges.filter(edge => edge.node.active && personIsVirtualUser(edge.node) && edge.node.client == null).length;
		this.getHeaderVisited = this.getHeaderVisited.bind(this);
		this.state = {
			page: this.props.trialEnded ? 'SELECT_PLAN' : 'LICENSING',
			perkListsExpanded: true,
			seats: Math.max(company.minimumSeats || 0, users),
			virtualSeats: Math.max(company.minimumVirtualSeats || 0, virtualUsers),
			name: company.name,
			street: company.street,
			zip: company.zip,
			city: company.city,
			vatId: company.vatId,
			country: company.country,
			contactName: company.contactName,
			contactEmail: company.contactEmail,
			contactPhone: company.contactPhone,
			isOnboarding: null,
			noOnboardingSelectedError: false,
			invoiceEmail: '',
			cardName: '',
			paymentType: 'invoice',
			coupon: null,
			appliedCoupon: null,
			discount_error: null,
			zip_error: false,
			vat_error: false,
			visitedPages: [],
			billing: 'annual',
			term: '1 Year',
			selectedTier: this.props.viewer.company.companySize === '501+' ? 'ENTERPRISE' : 'PRO',
			currency: this.getCurrencies().some(currency => currency.value === company.currency) ? company.currency : 'USD',
		};

		const {formatMessage} = this.props.intl;

		this.availableHeaders = [
			{id: 'LICENSING', label: formatMessage({id: 'select_plan.licensing'}), onClick: this.navigateWithValidation.bind(this, 'LICENSING'), disabled: true},
			{id: 'ONBOARDING', label: formatMessage({id: 'settings_subscription.onboarding'}), onClick: this.navigateWithValidation.bind(this, 'ONBOARDING'), disabled: true},
			{id: 'COMPANY_DETAILS', label: formatMessage({id: 'company_details.title'}), onClick: this.navigateWithValidation.bind(this, 'COMPANY_DETAILS'), disabled: true},
			{id: 'PAYMENT', label: formatMessage({id: 'payment.title'}), onClick: this.navigateWithValidation.bind(this, 'PAYMENT'), disabled: true},
			//{id: 'COMPLETE', label: 'Complete Order', onClick: null, noClick: true}
		];
		if (this.props.viewer.company.trialEnded) {
			if (!window.location.hash || window.location.hash !== '#select_plan') {
				this.props.history.replace('/trial-end#select_plan');
			}
		} else {
			if (!window.location.hash || (window.location.hash !== '#licensing' && this.props.viewer.company.tier === TIERS.TRIAL)) {
				this.props.history.replace('/trial-end#licensing');
			}
		}
	}

	UNSAFE_componentWillMount() {
		if (this.props.viewer.company.tier !== TIERS.TRIAL) {
			this.props.history.push({
				pathname: '/',
			});
		}
	}

	componentDidMount() {
		// Segment
		document.title = 'Trial ended - Forecast';
		tracking.trackPage('trial-end');
		this.setState({visitedPages: [this.state.page]});
	}

	UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
		if (this.state.page === 'COMPLETE') {
			return;
		}
		const curLocation = window.location.hash + '';
		if (curLocation.replace('#', '').toUpperCase() !== this.state.page && window.location.href.includes('trial-end')) {
			this.navigateWithValidation(curLocation.replace('#', '').toUpperCase());
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.page === 'COMPANY_DETAILS' && !this.state.seenCompanyDetails) {
			this.setState({seenCompanyDetails: true});
		}
	}

	setSelectedPlan(val) {
		this.setState({selectedPlan: val, perkListsExpanded: true});
		if (val === 'ENTERPRISE') {
			this.setState({
				billing: 'annual',
			});
		}

		if (this.state.paymentType === 'quarter' || val === 'LITE') {
			this.setState({
				paymentType: 'card',
			});
		} else {
			this.setState({
				paymentType: 'invoice',
			});
		}
	}

	navigateWithPlan(val) {
		this.setState({selectedTier: val}, () => this.navigateWithValidation('LICENSING'));
	}

	processCouponValidation(result) {
		if (result.validateCoupon.found) {
			const coupon = result.validateCoupon;
			if (this.state.billing === 'annual') {
				if (coupon.duration === 'repeating' && coupon.percentOff !== null && coupon.durationInMonths % 12 !== 0) {
					this.setState({loading: false, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-not-annual'})});
					return;
				}
			} else {
				// Check that the coupon is not a yearly only coupon
				if (coupon.couponId.toUpperCase().endsWith('YEARLY')) {
					this.setState({loading: false, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-only-annual'})});
					return;
				}
			}
			this.setState({appliedCoupon: result.validateCoupon, loading: false, discount_error: null});
		} else {
			this.setState({loading: false, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-not-valid'})});
		}
	}

	applyCoupon() {
		this.setState({loading: true});
		Util.CommitMutation(
			ValidateCouponMutation,
			{
				couponId: this.state.coupon || '',
			},
			this.processCouponValidation.bind(this)
		);
	}

	setDiscountCode(val) {
		this.setState({coupon: val, discount_error: null});
	}

	setBilling(val) {
		const coupon = this.state.appliedCoupon;
		if (coupon && coupon.duration === 'repeating' && coupon.percentOff !== null && coupon.durationInMonths % 12 !== 0) {
			this.setState({billing: val, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-not-annual'}), appliedCoupon: null});
		} else if (coupon && coupon.couponId.toUpperCase().endsWith('YEARLY')) {
			this.setState({billing: val, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-only-annual'}), appliedCoupon: null});
		} else {
			this.setState({billing: val});
		}
	}

	onCloseClick() {
		this.setState({page: null});
		if (this.props.closeModal) {
			this.props.closeModal();
		}
	}

	setPaymentType(val) {
		if (this.state.paymentType !== val) {
			this.setState({paymentType: val});
		}
	}

	selectOnboarding(val) {
		if (this.state.noOnboardingSelectedError === true) {
			this.setState({noOnboardingSelectedError: false});
		}
		if (this.state.isOnboarding !== val) {
			this.setState({isOnboarding: val});
		}
	}

	handleFieldChange(property, e) {
		this.setState({[property]: e.target ? e.target.value : e});
		if (property === 'zip') {
			this.setState({zip_error: false});
		}
	}

	handleChangeCountry(selection) {
		const country = selection ? selection.value : null;
		this.setState({country});
		Util.CommitMutation(UpdateCompanyMutation, {
			id: this.props.viewer.company.id,
			country,
		});
	}

	handleClientSave(property) {
		Util.CommitMutation(UpdateCompanyMutation, {
			id: this.props.viewer.company.id,
			[property]: this.state[property],
		});
	}

	// Validate whether we can go to target page
	getCanGoToPage(pageName) {
		let validTemp = null;
		switch (pageName) {
			case 'COMPLETE':
				validTemp = this.state.paymentType === 'card' ? this.state.invoiceEmail && this.state.contactName : this.state.contactName && this.state.contactEmail && this.state.invoiceEmail && this.state.contactPhone;
				return validTemp !== null && validTemp !== '';
			case 'PAYMENT':
				validTemp = this.state.name && this.state.street && this.state.zip && this.state.city && this.state.country && this.state.seats && this.state.virtualSeats && this.state.contactName && this.state.contactEmail;
				if (this.state.country && EU_COUNTRIES_CODES.includes(this.state.country) && !this.state.vatId) {
					validTemp = '';
				}
				return this.state.seenCompanyDetails && validTemp !== null && validTemp !== '' && this.validateSeats() && this.validateVirtualSeats();
			case 'LICENSING':
				return this.getSelectedPlan() != null;
			case 'COMPANY_DETAILS':
				if (this.state.isOnboarding === null) {
					this.setState({noOnboardingSelectedError: true});
				}
				return this.state.isOnboarding !== null;
			case 'ONBOARDING':
				validTemp = this.getSelectedPlan() && this.state.seats && this.state.virtualSeats;
				return validTemp !== null && validTemp !== '' && this.validateSeats() && this.validateVirtualSeats();
			default:
				return true;
		}
	}

	// Focus missing fields on existing page
	focusMissingFields(focusZip = false, focusVat = false) {
		if (this.state.page === 'COMPANY_DETAILS') {
			let field = null;
			if (!this.state.name) {
				field = document.getElementById('company_name');
			} else if (!this.state.street) {
				field = document.getElementById('company_street');
			} else if (!this.state.zip || focusZip) {
				field = document.getElementById('company_zip');
			} else if (!this.state.city) {
				field = document.getElementById('company_city');
			} else if (!this.state.country && this.countryInput) {
				this.countryInput.focus();
				return;
			} else if ((this.state.country && EU_COUNTRIES_CODES.includes(this.state.country) && !this.state.vatId) || focusVat) {
				field = document.getElementById('company_vat');
			} else if (!this.state.contactName) {
				field = document.getElementById('company_contact_name');
			} else if (!this.state.contactEmail) {
				field = document.getElementById('company_contact_email');
			}
			if (field) {
				field.focus();
			}
		} else if (this.state.page === 'PAYMENT') {
			if (this.state.paymentType === 'invoice') {
				if (!this.state.contactName) {
					const field = document.getElementById('company_contact_name');
					field.focus();
				} else if (!this.state.contactEmail) {
					const field = document.getElementById('company_contact_email');
					field.focus();
				} else if (!this.state.contactPhone) {
					const field = document.getElementById('company_contact_phone');
					field.focus();
				} else if (!this.state.invoiceEmail) {
					const field = document.getElementById('invoice_email');
					field.focus();
				}
			} else {
				if (!this.state.invoiceEmail) {
					const field = document.getElementById('invoice_email');
					field.focus();
				} else if (!this.state.contactName) {
					const field = document.getElementById('company_contact_name');
					field.focus();
				}
			}
		} else if (this.state.page === 'LICENSING') {
			if (!this.state.seats || !this.validateSeats()) {
				const field = document.getElementById('company_seats');
				field.focus();
			} else if (!this.state.virtualSeats || !this.validateVirtualSeats()) {
				const field = document.getElementById('company_virtual_seats');
				field.focus();
			}
		} else if (this.state.page === 'ONBOARDING') {
			if (this.state.isOnboarding == null) {
				const field = document.getElementById('onboarding-selector-wrapper');
				if (field) {
					field.focus();
				}
			}
		}
	}

	validateSeats() {
		const users = this.props.viewer.company.allPersons.edges.filter(edge => edge.node.active && !personIsClientUser(edge.node) && !personIsVirtualUser(edge.node)).length;
		return this.state.seats >= this.props.viewer.company.minimumSeats && this.state.seats >= users;
	}

	validateVirtualSeats() {
		const virtualUsers = this.props.viewer.company.allPersons.edges.filter(edge => edge.node.active && personIsVirtualUser(edge.node) && edge.node.client == null).length;
		return this.state.virtualSeats >= virtualUsers;
	}

	onCompleteOrder() {
		window.location.href = '/settings/subscription';
	}

	focusZip() {
		this.setState({page: 'COMPANY_DETAILS', zip_error: true}, () => {
			this.props.history.push('/trial-end#' + 'COMPANY_DETAILS'.toLowerCase());
			this.focusMissingFields(true);
		});
	}

	focusVat() {
		this.setState({page: 'COMPANY_DETAILS', vat_error: true}, () => {
			this.props.history.push('/trial-end#' + 'COMPANY_DETAILS'.toLowerCase());
			this.focusMissingFields(false, true);
		});
	}

	navigateWithValidation(pageName) {
		// Validate current page
		const valid = this.getCanGoToPage(pageName);

		// Navigate to new
		if (valid) {
			if (this.state.page !== pageName) {
				if (pageName === 'ONBOARDING' && !this.getOnboarding(this.getSelectedPlan())) {
					this.setState({
						isOnboarding: false,
					});
				}
				const visitedPages = this.state.visitedPages;
				visitedPages.push(pageName);
				this.setState({page: pageName, visitedPages}, () => {
					this.props.history.push('/trial-end#' + pageName.toLowerCase());
				});
			}
		} else {
			this.focusMissingFields();
			if (this.state.page) {
				this.props.history.replace('/trial-end#' + this.state.page.toLowerCase());
			}
		}
	}

	getHeaderVisited(headerId) {
		return !!this.state.visitedPages.find(page => page === headerId);
	}

	handleLogout() {
		const onSuccess = () => {
			tracking.logout();
			window.location.href = window.location.origin;
		};

		Util.CommitMutation(LogoutMutation, null, onSuccess);
	}

	getTotalWithVat() {
		return this.reciept.getTotalWithVat();
	}

	getPlansWithBillingCycle(billing, plans) {
		switch (billing) {
			case 'month':
				return plans.filter(plan => plan.periodUnit === 'MONTH' && plan.period === 1);
			case 'quarter':
				return plans.filter(plan => plan.periodUnit === 'MONTH' && plan.period === 3);
			case 'annual':
				return plans.filter(plan => plan.periodUnit === 'YEAR' && plan.period === 1);
		}
	}

	selectPlan(val) {
		if (val === 'ENTERPRISE') {
			this.setState({
				billing: 'annual',
			});
		}
		this.setState({selectedTier: val, perkListsExpanded: true});
	}

	getCurrencies() {
		let availablePlans = this.props.viewer.chargebeePlan.filter(plan => (this.state ? plan.chargebeeId.includes(this.state.selectedTier.toLowerCase()) : true));
		let currencies = [];
		if (this.state) {
			availablePlans = this.getPlansWithBillingCycle(this.state.billing, availablePlans);
		}
		availablePlans.forEach(plan => {
			const currency = {
				label: plan.currency,
				value: plan.currency,
			};
			currencies.push(currency);
		});

		return currencies;
	}

	getSelectedPlan() {
		const {selectedTier, billing, currency} = this.state;

		const availablePlans = this.props.viewer.chargebeePlan.filter(plan => plan.chargebeeId.includes(selectedTier.toLowerCase()) && plan.currency === currency);
		return this.getPlansWithBillingCycle(billing, availablePlans)[0];
	}

	selectBilling(val) {
		const coupon = this.state.appliedCoupon;
		if (coupon && coupon.duration === 'repeating' && coupon.percentOff !== null && coupon.durationInMonths % 12 !== 0) {
			this.setState({discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-not-annual'}), appliedCoupon: null});
		} else if (coupon && coupon.couponId.toUpperCase().endsWith('YEARLY')) {
			this.setState({discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-only-annual'}), appliedCoupon: null});
		}

		if (val === 'quarter' || this.props.selectedPlan === 'LITE') {
			this.setState({paymentType: 'card'});
		} else {
			this.setState({paymentType: 'invoice'});
		}
		this.setState({billing: val});
	}

	selectCurrency(val) {
		this.setState({currency: val.value});
	}

	getVirtualUser(selectedPlan) {
		const virtualUser = this.props.viewer.chargebeeAddon.filter(addon => addon.chargebeeId.includes('virtual_user') && addon.currency === selectedPlan.currency)[0];
		return virtualUser;
	}

	getOnboarding(selectedPlan) {
		return this.props.viewer.chargebeeAddon.filter(addon => addon.chargebeeId.includes('onboarding') && addon.currency === selectedPlan.currency && !addon.chargebeeId.includes('large'))[0];
	}

	render() {
		let page;
		const {formatDate} = this.props.intl;
		const users = this.props.viewer.company.allPersons.edges.filter(edge => edge.node.active && !personIsVirtualUser(edge.node) && !personIsClientUser(edge.node)).length;
		const virtualUsers = this.props.viewer.company.allPersons.edges.filter(edge => edge.node.active && personIsVirtualUser(edge.node) && edge.node.client == null).length;
		const dueDate = this.props.viewer.company.trialEnded ? null : Util.CreateMomentDate(this.props.viewer.company.trialEndYear, this.props.viewer.company.trialEndMonth, this.props.viewer.company.trialEndDay);

		const selectedPlan = this.getSelectedPlan();
		const currencies = this.getCurrencies();
		const selectedVirtualUser = this.getVirtualUser(selectedPlan);
		const selectedOnboarding = this.getOnboarding(selectedPlan);

		const receiptProps = {
			hideTotal: this.state.page === 'LICENSING',
			hideMonthly: this.state.page === 'COMPLETE',
			dueDate: dueDate,
			page: this.state.page,
			users: users,
			virtualUsers: virtualUsers,
			seats: this.state.seats,
			virtualSeats: this.state.virtualSeats,
			billing: this.state.billing,
			setBilling: this.setBilling.bind(this),
			setPaymentType: this.setPaymentType.bind(this),
			isOnboarding: this.state.isOnboarding,
			appliedCoupon: this.state.appliedCoupon,
			discount_error: this.state.discount_error,
			applyCoupon: this.applyCoupon.bind(this),
			setDiscountCode: this.setDiscountCode.bind(this),
			validateSeats: this.validateSeats.bind(this),
			validateVirtualSeats: this.validateVirtualSeats.bind(this),
			selectedPlan: selectedPlan,
			hideBillingSelector: this.state.page === 'COMPLETE',
			isPaid: this.state.page === 'COMPLETE',
			country: this.props.viewer.company.country,
			currencySymbol: Util.GetCurrencySymbol(this.state.currency),
			virtualUser: this.getVirtualUser(selectedPlan),
			selectedTier: this.state.selectedTier,
		};
		switch (this.state.page) {
			case 'SELECT_PLAN':
				page = (
					<SelectPlan
						selectedPlan={this.state.selectedPlan}
						perkListsExpanded={this.state.perkListsExpanded}
						clearSelectedPlan={this.setSelectedPlan.bind(this, null)}
						navigateWithPlan={this.navigateWithPlan.bind(this)}
						setSelectedPlan={this.setSelectedPlan.bind(this)}
						viewer={this.props.viewer}
						setPage={this.navigateWithValidation.bind(this)}
						plans={this.props.viewer.chargebeePlan}
						currency={this.state.currency}
						selectedVirtualUser={selectedVirtualUser}
					/>
				);
				break;
			case 'LICENSING':
				page = (
					<Licensing
						allPersons={this.props.viewer.company.allPersons.edges}
						canGoBack={this.props.viewer.company.trialEnded}
						selectPlan={this.selectPlan.bind(this)}
						selectedPlan={selectedPlan}
						viewer={this.props.viewer}
						minimumSeats={this.props.viewer.company.minimumSeats}
						minimumVirtualSeats={this.props.viewer.company.minimumVirtualSeats}
						users={users}
						virtualUsers={virtualUsers}
						seats={this.state.seats}
						virtualSeats={this.state.virtualSeats}
						handleFieldChange={this.handleFieldChange.bind(this)}
						handleClientSave={this.handleClientSave.bind(this)}
						validateSeats={this.validateSeats.bind(this)}
						validateVirtualSeats={this.validateVirtualSeats.bind(this)}
						setPage={this.navigateWithValidation.bind(this)}
						setPaymentType={this.setPaymentType.bind(this)}
						setBilling={this.setBilling.bind(this)}
						currencies={currencies}
						currency={this.state.currency}
						selectedTier={this.state.selectedTier}
						selectCurrency={this.selectCurrency.bind(this)}
						plans={this.props.viewer.chargebeePlan}
					/>
				);
				break;
			case 'ONBOARDING':
				page = (
					<OnboardingCard
						viewer={this.props.viewer}
						selectedTier={this.state.selectedTier}
						isOnboarding={this.state.isOnboarding}
						noOnboardingSelectedError={this.state.noOnboardingSelectedError}
						setPage={this.navigateWithValidation.bind(this)}
						selectOnboarding={this.selectOnboarding.bind(this)}
						onboarding={selectedOnboarding}
						currencySymbol={Util.GetCurrencySymbol(this.state.currency)}
						currency={this.state.currency}
					/>
				);
				break;
			case 'COMPANY_DETAILS':
				page = (
					<CompanyDetails
						upgradeNow={!this.props.viewer.company.trialEnded}
						minimumSeats={this.props.viewer.company.minimumSeats}
						selectedPlan={this.state.selectedPlan}
						users={users}
						virtualUsers={virtualUsers}
						viewer={this.props.viewer}
						name={this.state.name}
						street={this.state.street}
						zip={this.state.zip}
						zip_error={this.state.zip_error}
						vat_error={this.state.vat_error}
						city={this.state.city}
						vatId={this.state.vatId}
						country={this.state.country}
						contactName={this.state.contactName}
						contactEmail={this.state.contactEmail}
						contactPhone={this.state.contactPhone}
						seats={this.state.seats}
						virtualSeats={this.state.virtualSeats}
						setPage={this.navigateWithValidation.bind(this)}
						handleFieldChange={this.handleFieldChange.bind(this)}
						handleChangeCountry={this.handleChangeCountry.bind(this)}
						handleClientSave={this.handleClientSave.bind(this)}
						validateSeats={this.validateSeats.bind(this)}
						validateVirtualSeats={this.validateVirtualSeats.bind(this)}
					/>
				);
				break;
			case 'PAYMENT':
				page = (
					<Payment
						changeCreditCard={false}
						appliedCoupon={this.state.appliedCoupon}
						billing={this.state.billing}
						contactName={this.state.contactName}
						name={this.state.name}
						contactEmail={this.state.contactEmail}
						contactPhone={this.state.contactPhone}
						paymentType={this.state.paymentType}
						invoiceEmail={this.state.invoiceEmail}
						cardName={this.state.cardName}
						viewer={this.props.viewer}
						selectedPlan={selectedPlan}
						handleFieldChange={this.handleFieldChange.bind(this)}
						handleClientSave={this.handleClientSave.bind(this)}
						setBilling={this.setBilling.bind(this)}
						setPage={this.navigateWithValidation.bind(this)}
						setPaymentType={this.setPaymentType.bind(this)}
						seats={this.state.seats}
						virtualSeats={this.state.virtualSeats}
						isOnboarding={this.state.isOnboarding}
						focusZip={this.focusZip.bind(this)}
						focusVat={this.focusVat.bind(this)}
						getTotalWithVat={this.getTotalWithVat.bind(this)}
						selectedVirtualUser={selectedVirtualUser}
						selectedOnboarding={selectedOnboarding}
					/>
				);
				break;
			case 'COMPLETE':
				page = <OrderComplete currency={this.state.currency} date={formatDate(Moment(), {month: 'long', day: 'numeric', year: 'numeric'})} receiptProps={receiptProps} onComplete={this.onCompleteOrder.bind(this)} />;
				break;
			default:
				break;
		}

		this.availableHeaders.forEach(header => (header.disabled = !this.getHeaderVisited(header.id)));
		const admins = this.props.viewer.company.allPersons.edges.filter(edge => personHasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS, edge.node));
		return (
			<div style={{position: 'absolute', left: '0px', top: '0px', height: '100%', width: '100%', display: 'flex', zIndex: '2'}}>
				<CustomScrollDiv>
					{!hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS) ? (
						<NoPermission viewer={this.props.viewer} admins={admins} />
					) : (
						<div className="fullscreen fullscreen-centered-outer trial-end-v2">
							{this.state.page === 'COMPLETE' ? null : (
								<TrialEndHeader
									page={this.state.page}
									showLogout={this.props.viewer.company.trialEnded}
									showNav={this.state.page !== 'SELECT_PLAN'}
									onLogoutClick={this.handleLogout.bind(this)}
									availableHeaders={this.availableHeaders}
									onCloseClick={this.onCloseClick.bind(this)}
								/>
							)}
							<div className="fullscreen-centered-inner">
								<div className="trial-end-wrapper">
									{page}
									{page != null && this.state.page !== 'SELECT_PLAN' && this.state.page !== 'COMPLETE' ? <Receipt currency={this.state.currency} ref={el => (this.reciept = el)} {...receiptProps} /> : null}
								</div>
							</div>
						</div>
					)}
				</CustomScrollDiv>
			</div>
		);
	}
}

const trialEndQuery = graphql`
	query trialEnd_Query {
		viewer {
			actualPersonId
			component(name: "trial_end")
			...trialEnd_viewer
		}
	}
`;

export {trialEndQuery};

export default createFragmentContainer(injectIntl(withRouter(trialEnd)), {
	viewer: graphql`
		fragment trialEnd_viewer on Viewer {
			id
			actualPersonId
			chargebeePlan {
				chargebeeId
				currency
				price
				period
				periodUnit
			}
			chargebeeAddon {
				chargebeeId
				currency
				price
			}
			company {
				id
				name
				street
				zip
				city
				country
				vatId
				tier
				companySize
				contactName
				contactEmail
				contactPhone
				trialEndYear
				trialEndMonth
				trialEndDay
				trialEndTime
				trialEnded
				minimumSeats
				minimumVirtualSeats
				jiraCloudEnabled
				jiraServerEnabled
				currency
				allPersons(first: 10000) {
					edges {
						node {
							id
							active
							role {
								id
								name
							}
							firstName
							lastName
							fullName
							permissions
							profilePictureId
							email
						}
					}
				}
			}
		}
	`,
});
